export default __webpack_public_path__ + "static/media/white_account_icon.5d48756f.svg";